import { useState } from 'react'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { ModalWrapper } from 'Components'
import customerService from 'Services/customerService'
import { useForm } from 'react-hook-form'

interface UpdateTierModalProps {
  setShowUpdateTierModal: (show: boolean) => void
  msisdn: string | undefined
}

type formProp = {
  tier: string
  productType: string
}

const CashBackTierModal: React.FC<UpdateTierModalProps> = ({ setShowUpdateTierModal, msisdn }) => {
  const { register, handleSubmit } = useForm<formProp>()
  const { showAlert } = ShowTGAlert()
  const [loading, setLoading] = useState(false)

  const onSubmit = async (data: formProp) => {
    setLoading(true)
    const msis = encodeURIComponent(msisdn ?? '')
    await customerService.updateTier(msis, data.tier, data.productType).then(
      () => {
        showAlert({
          message: 'Customer Tier Updated succesfully',
          show: true,
          title: 'Done!',
          type: 'success',
        })
        setShowUpdateTierModal(false)
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='mt-3'>
      <div className='mb-3'>
        <label htmlFor='productType' className='form-label fw-medium'>
          Select Product Type
        </label>
        <select
          id='productType'
          {...register('productType', { required: true })}
          className='form-control'
          defaultValue=''
          disabled={loading}
        >
          <option value='' disabled>
            Select
          </option>
          <option value='PMS'>PMS</option>
          <option value='AGO'>AGO</option>
        </select>
      </div>

      <div className='mb-3'>
        <label htmlFor='tier' className='form-label fw-medium'>
          Select Tier
        </label>
        <select
          id='tier'
          {...register('tier', { required: true })}
          className='form-control'
          defaultValue=''
          disabled={loading}
        >
          <option value='' disabled>
            Select a tier
          </option>
          <option value='T1'>Tier 1</option>
          <option value='T2'>Tier 2</option>
          <option value='T3'>Tier 3</option>
          <option value='T4'>Tier 4</option>
          <option value='T5'>Tier 5</option>
        </select>
      </div>

      <div className='d-flex justify-content-end gap-2'>
        <button
          type='button'
          className='btn btn-secondary'
          onClick={() => setShowUpdateTierModal(false)}
          disabled={loading}
        >
          Cancel
        </button>
        <button type='submit' className='btn btn-default' disabled={loading}>
          {loading ? (
            <span className='spinner-border spinner-border-sm text-dark'></span>
          ) : (
            'Update'
          )}
        </button>
      </div>
    </form>
  )
}

export default CashBackTierModal
